var exports = {
  "Q": "xa15a2ab7--ac62f4--content",
};

module.exports = exports;
